import { memo } from 'react';
import CommentAnchor from '../../ddvComment/directUser/CommentAnchor';

import {
  openSectionCommentPanel,
  shouldScrollInToView,
} from '@components/directUser/utils';

function AnalysisCommentAnchor({ children }) {
  return children || null;
}

export default CommentAnchor(memo(AnalysisCommentAnchor), {
  shouldScrollInToView,
  getAnchorIdFromProp({ record }) {
    return record?.value.replace(/\_/g, '/');
  },
  onDirectSuccess: openSectionCommentPanel,
});
